import { formatPercentages, formatUSD } from '../../helpers';
import ShareModal, { ShareModalType } from './ShareModal';
import useModalState from '../../context/modal/useModalState';
import { UserPosition } from '../../hooks/web3/trade/useUserPositions';

const ShareOpenPositionModal = () => {
    const { modalData } = useModalState();

    const userPosition: (UserPosition & { markPrice: string }) | undefined =
        modalData.data?.position;

    if (!userPosition || modalData.data?.type !== ShareModalType.OpenPosition)
        return null;

    return (
        <ShareModal
            type={ShareModalType.OpenPosition}
            modalName='shareOpenPositionModal'
            cardClass='user-open-ranking'
        >
            <div className='title'>Open position</div>
            <div className='trading-infos'>
                <span className='trading-infos__pair'>
                    {userPosition?.tradePair?.asset.symbol} USD
                </span>
                <span
                    className={`trading-infos__type ${
                        userPosition?.isShort ? 'short' : 'long'
                    }`}
                >
                    {userPosition?.isShort ? 'Short' : 'Long'}{' '}
                    {formatPercentages(userPosition?.leverage || 0)}x
                </span>
            </div>
            <span
                className={`trading-score ${
                    userPosition && +userPosition.pnlPercent >= 0
                        ? 'increased'
                        : 'decreased'
                }`}
            >
                {userPosition && +userPosition.pnlPercent > 0 && '+'}
                {formatPercentages(userPosition?.pnlPercent || 0)}%
            </span>
            <div className='prices-data'>
                <div>
                    <span>Entry Price</span>
                    <span>
                        {formatUSD(userPosition?.entryPrice || 0, {
                            minDecimals: 2,
                            maxDecimals: userPosition.tradePair.decimalFormatting,
                        })}
                    </span>
                </div>
                <div>
                    <span>Mark Price</span>
                    <span>
                        {formatUSD(userPosition?.markPrice || 0, {
                            minDecimals: 2,
                            maxDecimals: userPosition.tradePair.decimalFormatting,
                        })}
                    </span>
                </div>
            </div>
        </ShareModal>
    );
};

export default ShareOpenPositionModal;
